import { DateInput as DateInputField } from "@/components/form"
import type { PlainDate } from "@/temporal"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import type { GenericInputProps } from "./InputComponent"

type Props = GenericInputProps<PlainDate>

const DateInput: ReactiveComponent<Props> = (props) => {
	return () => <DateInputField value={props.value} setValue={props.setValue} required />
}

export default defineComponent(DateInput, inferProps<Props>())
